import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

// Numbered pagination with prev/next. Keeps a compact window around the current page.
export const AppPagination = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;

  const pages = [];
  const add = (p) => pages.push(p);
  add(1);
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) add('...l');
  for (let p = start; p <= end; p++) add(p);
  if (end < totalPages - 1) add('...r');
  if (totalPages > 1) add(totalPages);

  const btn = 'grid h-10 min-w-10 place-items-center rounded-xl border text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-200';

  return (
    <nav className="flex items-center justify-center gap-2" aria-label="Pagination" data-testid="pagination">
      <button type="button" disabled={page === 1} onClick={() => onChange(page - 1)} className={cn(btn, 'px-3 border-slate-200 bg-white text-slate-700 disabled:opacity-40')} data-testid="pagination-prev">
        <ChevronLeft size={16} />
      </button>
      {pages.map((p, i) =>
        typeof p === 'string' ? (
          <span key={i} className="px-2 text-slate-400">…</span>
        ) : (
          <button key={i} type="button" onClick={() => onChange(p)} aria-current={p === page} className={cn(btn, 'px-3', p === page ? 'border-blue-600 bg-blue-600 text-white' : 'border-slate-200 bg-white text-slate-700 hover:border-blue-300')} data-testid={`pagination-page-${p}`}>
            {p}
          </button>
        )
      )}
      <button type="button" disabled={page === totalPages} onClick={() => onChange(page + 1)} className={cn(btn, 'px-3 border-slate-200 bg-white text-slate-700 disabled:opacity-40')} data-testid="pagination-next">
        <ChevronRight size={16} />
      </button>
    </nav>
  );
};
